import type { FunctionComponent } from 'react';

import styles from './Dots.module.css';

interface DotsProps {
  dots: boolean;
  activeIndex: number;
  goTo: (index: number) => void;
  slideCount: number;
}

export const Dots: FunctionComponent<DotsProps> = ({ dots, activeIndex, goTo, slideCount }) => {
  if (!dots) {
    return;
  }

  return (
    <div
      className={styles.swiperDotsWrapper}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseMove={(e) => e.stopPropagation()}
      onMouseLeave={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
    >
      <ul className={styles.swiperDots}>
        {Array.from({ length: slideCount }, (_, k) => k).map((el) => {
          return (
            <li key={el}>
              <button
                type="button"
                className={
                  styles.swiperDotsItem +
                  ' ' +
                  (el === activeIndex ? styles.swiperDotBtnActive : '') +
                  ' ' +
                  (el + 1 === activeIndex || el - 1 === activeIndex ? styles.swiperDotNeighbor : '')
                }
                tabIndex={-1}
                onClickCapture={(e) => {
                  e.stopPropagation();
                  goTo(el);
                }}
              >
                <span className={styles.swiperDotInner} />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
